import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { BatchRequestsService } from './api/batchRequests.service';
import { ConstructionService } from './api/construction.service';
import { EquipmentService } from './api/equipment.service';
import { NotificationsService } from './api/notifications.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ConstructionCdsApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ConstructionCdsApiModule> {
        return {
            ngModule: ConstructionCdsApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ConstructionCdsApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ConstructionCdsApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
